export const TRANSLATION_KEYS = {
  COMMON: {
    BUTTON: {
      SAVE:   { key: 'COMMON.BUTTON.SAVE',   desc: 'Nút lưu dữ liệu' },
      CANCEL: { key: 'COMMON.BUTTON.CANCEL', desc: 'Nút hủy bỏ thao tác' },
      CLOSE:  { key: 'COMMON.BUTTON.CLOSE',  desc: 'Nút đóng popup/hộp thoại' },
      UPDATE: { key: 'COMMON.BUTTON.UPDATE', desc: 'Nút cập nhật dữ liệu' },
      DELETE: { key: 'COMMON.BUTTON.DELETE', desc: 'Nút xóa dữ liệu' },
      CONFIRM:{ key: 'COMMON.BUTTON.CONFIRM',desc: 'Nút xác nhận thao tác' },
      YES:    { key: 'COMMON.BUTTON.YES',    desc: 'Nút đồng ý (Yes)' },
      NO:     { key: 'COMMON.BUTTON.NO',     desc: 'Nút từ chối (No)' },
    },
  },

  ERROR: {
    REQUIRED:          { key: 'ERROR.REQUIRED',          desc: 'Trường bắt buộc' },
    INVALID_EMAIL:     { key: 'ERROR.INVALID_EMAIL',     desc: 'Email không hợp lệ' },
    INVALID_PHONE:     { key: 'ERROR.INVALID_PHONE',     desc: 'Số điện thoại không hợp lệ' },
    MIN_LENGTH:        { key: 'ERROR.MIN_LENGTH',        desc: 'Chuỗi ngắn hơn số ký tự tối thiểu' },
    MAX_LENGTH:        { key: 'ERROR.MAX_LENGTH',        desc: 'Chuỗi dài hơn số ký tự tối đa' },
    PATTERN:           { key: 'ERROR.PATTERN',           desc: 'Sai định dạng' },
    PASSWORD_MISMATCH: { key: 'ERROR.PASSWORD_MISMATCH', desc: 'Mật khẩu không khớp' },
    USERNAME_EXISTS:   { key: 'ERROR.USERNAME_EXISTS',   desc: 'Tên đăng nhập đã tồn tại' },
    EMAIL_EXISTS:      { key: 'ERROR.EMAIL_EXISTS',      desc: 'Email đã được đăng ký' },

    UNAUTHORIZED:      { key: 'ERROR.UNAUTHORIZED',      desc: 'Chưa đăng nhập hoặc token hết hạn' },
    FORBIDDEN:         { key: 'ERROR.FORBIDDEN',         desc: 'Không có quyền truy cập' },
    SESSION_EXPIRED:   { key: 'ERROR.SESSION_EXPIRED',   desc: 'Phiên đăng nhập hết hạn' },
    ACCOUNT_LOCKED:    { key: 'ERROR.ACCOUNT_LOCKED',    desc: 'Tài khoản bị khóa' },
    ACCOUNT_INACTIVE:  { key: 'ERROR.ACCOUNT_INACTIVE',  desc: 'Tài khoản chưa kích hoạt' },

    NOT_FOUND:         { key: 'ERROR.NOT_FOUND',         desc: 'Không tìm thấy dữ liệu' },
    DUPLICATE:         { key: 'ERROR.DUPLICATE',         desc: 'Dữ liệu bị trùng lặp' },
    INVALID_INPUT:     { key: 'ERROR.INVALID_INPUT',     desc: 'Dữ liệu nhập vào không hợp lệ' },
    DEPENDENCY_EXISTS: { key: 'ERROR.DEPENDENCY_EXISTS', desc: 'Không thể xóa do có ràng buộc dữ liệu' },
    UPLOAD_FAILED:     { key: 'ERROR.UPLOAD_FAILED',     desc: 'Tải lên file thất bại' },
    INVALID_FILE_TYPE: { key: 'ERROR.INVALID_FILE_TYPE', desc: 'Định dạng file không hợp lệ' },
    FILE_TOO_LARGE:    { key: 'ERROR.FILE_TOO_LARGE',    desc: 'File vượt quá dung lượng cho phép' },

    SERVER_ERROR:      { key: 'ERROR.SERVER_ERROR',      desc: 'Lỗi hệ thống' },
    NETWORK_ERROR:     { key: 'ERROR.NETWORK_ERROR',     desc: 'Không thể kết nối máy chủ' },
    TIMEOUT:           { key: 'ERROR.TIMEOUT',           desc: 'Hết thời gian xử lý' },
    SERVICE_UNAVAILABLE:{ key: 'ERROR.SERVICE_UNAVAILABLE', desc: 'Dịch vụ tạm thời không khả dụng' },
    UNKNOWN_ERROR:     { key: 'ERROR.UNKNOWN_ERROR',     desc: 'Lỗi không xác định' }
  },
  TOAST: {
      SUCCESS: { key: 'TOAST.SUCCESS', desc: 'Thông báo thành công' },
      ERROR:   { key: 'TOAST.ERROR',   desc: 'Thông báo lỗi' },
      WARNING: { key: 'TOAST.WARNING', desc: 'Thông báo cảnh báo' },
      INFO:    { key: 'TOAST.INFO',    desc: 'Thông báo thông tin' }
    }
} as const;
